import { useEffect } from "react";
import { PAGE_SEO } from "../data/content";

export default function SeoHead({ page }) {
  const seo = PAGE_SEO[page] || PAGE_SEO.home;

  useEffect(() => {
    // Title
    document.title = seo.title;

    // Helper to set or create a meta tag
    const setMeta = (selector, attr, value) => {
      let el = document.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };

    setMeta('meta[name="description"]',          "content", seo.description);
    setMeta('meta[name="keywords"]',             "content", seo.keywords);
    setMeta('meta[name="robots"]',               "content", "index, follow");
    setMeta('meta[name="author"]',               "content", "Buyp Tech Technologies");

    // Open Graph
    setMeta('meta[property="og:title"]',         "content", seo.title);
    setMeta('meta[property="og:description"]',   "content", seo.description);
    setMeta('meta[property="og:type"]',          "content", "website");
    setMeta('meta[property="og:url"]',           "content", "https://ooon.in");
    setMeta('meta[property="og:image"]',         "content", "https://ooon.in/img/Ooon.png");
    setMeta('meta[property="og:site_name"]',     "content", "Ooon POS");
    setMeta('meta[property="og:locale"]',        "content", "en_IN");

    // Twitter Card
    setMeta('meta[name="twitter:card"]',         "content", "summary_large_image");
    setMeta('meta[name="twitter:title"]',        "content", seo.title);
    setMeta('meta[name="twitter:description"]',  "content", seo.description);
    setMeta('meta[name="twitter:image"]',        "content", "https://ooon.in/img/Ooon.png");
    setMeta('meta[name="twitter:site"]',         "content", "@BuypTech");

    // Canonical
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    const paths = { home: "/", about: "/about", features: "/features", contact: "/contact" };
    canonical.setAttribute("href", `https://ooon.in${paths[page] || "/"}`);

  }, [page, seo]);

  return null; // renders nothing — only side-effects
}
